import type { CSSProperties, PropsWithChildren, ReactNode } from "react";
import { type BorderRadius, Colors, type TextAlignment } from "schemas";

function pxBorderRadius(borderRadius: BorderRadius): string {
  switch (borderRadius) {
    case "Rounded":
      return "32px";
    case "Smooth":
      return "4px";
    case "Square":
      return "0";
  }
}

const commonButtonStyles = (
  buttonBackgroundColor: string,
  buttonTextColor: string,
  buttonTextAlignment: TextAlignment,
  buttonBorderRadius: BorderRadius,
) =>
  ({
    fill: buttonTextColor || Colors.Neutral500,
    display: "block",
    padding: "20px",
    position: "relative",
    borderRadius: pxBorderRadius(buttonBorderRadius),
    backgroundColor: buttonBackgroundColor || Colors.Neutral0,
    color: buttonTextColor || Colors.Neutral500,
    textDecoration: "none",
    textAlign: buttonTextAlignment === "Center" ? "center" : "left",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    marginBottom: "20px",
  }) as CSSProperties;

const iconContainerStyles = (buttonTextAlignment: TextAlignment) =>
  ({
    display: "inline-block",
    width: buttonTextAlignment === "Center" ? "auto" : "10%",
    marginLeft: buttonTextAlignment === "Center" ? "8px" : "",
    textAlign: "right",
    lineHeight: "20px",
    paddingTop: "2px",
    verticalAlign: "middle",
  }) as CSSProperties;

const iconStyles: CSSProperties = {
  width: "20px",
  height: "20px",
};

const contentContainerStyles = (buttonTextAlignment: TextAlignment) =>
  ({
    display: "inline-block",
    width: buttonTextAlignment === "Center" ? "auto" : "90%",
  }) as CSSProperties;

interface Props extends PropsWithChildren {
  href: string;
  iconSrc: string;
  extra?: ReactNode;
  contentRef?: (node: HTMLElement | null) => void;
  buttonBackgroundColor: string;
  buttonTextColor: string;
  buttonTextAlignment: TextAlignment;
  buttonBorderRadius: BorderRadius;
}

export function LinkButton({
  href,
  iconSrc,
  children,
  extra,
  contentRef,
  buttonBackgroundColor,
  buttonTextColor,
  buttonTextAlignment,
  buttonBorderRadius,
}: Props) {
  return (
    <a
      href={href}
      target="_blank"
      style={commonButtonStyles(buttonBackgroundColor, buttonTextColor, buttonTextAlignment, buttonBorderRadius)}
      rel="noreferrer"
    >
      {contentRef ? <div style={contentContainerStyles(buttonTextAlignment)} ref={contentRef} /> : null}
      {children}
      <div style={iconContainerStyles(buttonTextAlignment)}>
        <img style={iconStyles} src={iconSrc} alt="icon" />
      </div>
      {extra}
    </a>
  );
}
